export default "__VITE_ASSET__836fcb1e__"